import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import {
    IABCMoneda,
    ICreateABCMonedaResp,
    IGetABCMonedasResp,
    IGetParidadXFechaResp,
    IGetParidadXMonedaResp,
    IParidadMoneda,
} from "../interfaces/IGetABCMonedas";

@Injectable({
    providedIn: "root",
})
export class AbcMonedasService {
    constructor(private http: HttpClient) {}

    GetABCMonedas() {
        return this.http.get<IGetABCMonedasResp>(environment.apiNewBackBaseUrl + "ABCMoneda/GetABCMonedas");
    }

    CreateABCMoneda(payload: IABCMoneda) {
        return this.http.post<ICreateABCMonedaResp>(environment.apiNewBackBaseUrl + "ABCMoneda/CreateABCMoneda", payload);
    }

    DeleteABCMoneda(moneda: string) {
        return this.http.post<ICreateABCMonedaResp>(environment.apiNewBackBaseUrl + "ABCMoneda/DeleteABCMoneda", {
            moneda: moneda,
        });
    }

    EditABCMoneda(payload: IABCMoneda) {
        return this.http.post<ICreateABCMonedaResp>(environment.apiNewBackBaseUrl + "ABCMoneda/EditABCMoneda", payload);
    }

    GetParidadXMoneda(moneda: string) {
        return this.http.post<IGetParidadXMonedaResp>(environment.apiNewBackBaseUrl + "Paridad/GetParidadXMoneda", {
            moneda: moneda,
            tope: "100",
        });
    }

    GetParidadXFecha(moneda: string, fecha: string) {
        return this.http.post<IGetParidadXFechaResp>(environment.apiNewBackBaseUrl + "Paridad/GetParidadXFecha", {
            moneda: moneda,
            fecha: fecha,
        });
    }

    CreateParidad(payload: IParidadMoneda) {
        return this.http.post<ICreateABCMonedaResp>(environment.apiNewBackBaseUrl + "Paridad/CreateParidad", payload);
    }

    EditParidad(payload: IParidadMoneda) {
        return this.http.post<ICreateABCMonedaResp>(environment.apiNewBackBaseUrl + "Paridad/EditParidad", payload);
    }

    DeleteParidad(moneda: string, fecha: string) {
        return this.http.post<ICreateABCMonedaResp>(environment.apiNewBackBaseUrl + "Paridad/DeleteParidad", {
            moneda: moneda,
            fecha: fecha,
        });
    }
}
